import { string, pipe, minLength, regex, object, nonEmpty } from "valibot";

export const passwordFields = object({
    password: pipe(
        string(),
        minLength(8, "Password does not meet requirements."),
        regex(/[A-Z]/, "Password does not meet requirements."),
        regex(/[a-z]/, "Password does not meet requirements."),
        regex(/[0-9]/, "Password does not meet requirements."),
        regex(
            /[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=]/,
            "Password does not meet requirements."
        )
    ),
    confirmPassword: pipe(string(), nonEmpty("Cannot be empty.")),
});
